import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import BelvoTestData from "./BelvoData/BelvoTestData";
import Register from "./Authentication/Register";
import Login from "./Authentication/Login";
import ForgotPassword from "./Authentication/ForgotPassword";
import DashboardMentor from "./Dashboards/DashboardMentor";
import DashboardMentorUser from "./Dashboards/DashboardMentorUser";
import {
  userLogin,
  userLogout,
  setUser,
  setIsAdmin,
  setIsMentor,
  setIsSherpa,
  setToken,
  setUserId,
  setIsBusiness,
  setMantisBusiness,
} from "./Redux/modules/auth";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { verifyToken, logout } from "./ApiCalls/authentication";
import SidebarMenuComponent from "./Backoffice/SidebarMenu";
import BackofficeHome from "./Backoffice/BackofficeHome";
import MonthlyPayments from "./Backoffice/MonthlyPayments";
import "./App.scss";
import EmailValidation from "./Extras/EmailValidation";
import TermsAndConditions from "./Extras/TermsAndConditions";
import Mandato from "./Extras/Mandato";
import RecurringPaymentDetail from "./Backoffice/RecurringPaymentDetail";
import Investments from "./Backoffice/Investments";
import InvestmentDetail from "./Backoffice/InvestmentDetail";
import Tpaga from "./Backoffice/Tpaga";
import PlanCalculator from "./Backoffice/PlanCalculator";
import DataTreatment from "./Extras/DataTreatment";
import DataTreatmentAuhorization from "./Extras/DataTreatmentAuthorization";
import AboutUs from "./Extras/AboutUs";
import PaymentLinks from "./Backoffice/PaymentLinks";
import MoneyOnMandates from "./Backoffice/MoneyOnMandates";
import Dashboard from "./Backoffice/Dashboard";
import DownloadMasterClass from "./Extras/DownloadMasterClass";
import WhatsappNotifications from "./Backoffice/Notifications/WhatsappNotifications";
import Billing from "./Backoffice/Billing";
import EficaciaDemo from "./Backoffice/EficaciaDemo";
import PushNotifications from "./Backoffice/Notifications/PushNotifications";
import PrecreatedUserDownloadMantis from "./Extras/PrecreatedUserDownloadMantis";
import StartcoConversations from "./Backoffice/StartcoConversations";
import MantisBusinesses from "./Backoffice/MantisBusinesses";
import MantisBusinessDetail from "./Backoffice/components/MantisBusinessDetailWithTabs";
import Agentes from "./Backoffice/Agentes";
import LLMModels from "./Backoffice/LLMModels";
import ForgotPasswordBusiness from "./Authentication/ForgotPasswordBusiness";
import YCLandingPage from "./YC/LandingYC";
import Blog from "./YC/Blog";
import BlogDetail from "./YC/BlogDetail";
import SystemLogs from "./Backoffice/SystemLogs";

function mapDispatchToProps(dispatch) {
  return {
    userLogin: () => dispatch(userLogin()),
    userLogout: () => dispatch(userLogout()),
    setUser: (user) => dispatch(setUser(user)),
    setUserId: (userId) => dispatch(setUserId(userId)),
    setIsAdmin: (isAdmin) => dispatch(setIsAdmin(isAdmin)),
    setIsSherpa: (isSherpa) => dispatch(setIsSherpa(isSherpa)),
    setIsMentor: (isMentor) => dispatch(setIsMentor(isMentor)),
    setToken: (token) => dispatch(setToken(token)),
    setIsBusiness: (isBusiness) => dispatch(setIsBusiness(isBusiness)),
    setMantisBusiness: (mantisBusiness) =>
      dispatch(setMantisBusiness(mantisBusiness)),
  };
}

const select = (state) => {
  return {
    user: state.auth.user,
    authenticated: state.auth.authenticated,
    isBusiness: state.auth.isBusiness,
    mantisBusiness: state.auth.mantisBusiness,
  };
};

function App(props) {
  useEffect(() => {
    verifySession();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- verifySession should only run once on mount
  }, []);

  // L-01 (MA-06): the JWT lives in an httpOnly mantis_session cookie now, so there's
  // nothing to read from storage. The non-httpOnly csrfToken cookie (set by the
  // backend at login/verifyToken) is the only readable signal a session might exist —
  // gate on that instead, same as before, just sourced from the cookie.
  async function verifySession() {
    if (!Cookies.get("csrfToken")) return;

    const json = await verifyToken();
    if (json.success) {
      props.setUser({ user: json.user });
      props.setUserId({ userId: json.userId });
      props.setToken({ token: "undefined" });
      props.setIsAdmin({ isAdmin: json.isAdmin });
      props.setIsMentor({ isMentor: json.isMentor });
      props.setIsSherpa({ isSherpa: json.isSherpa });
      props.setIsBusiness({ isBusiness: json.isBusiness });
      props.setMantisBusiness({ mantisBusiness: json.mantisBusiness });
      props.userLogin();
    } else {
      logout();
      props.userLogout();
    }
  }

  return (
    <div className="home-component">
      <BrowserRouter>
        {props.authenticated && !props.isBusiness && (
          <>
            {/* Hide navbar on mantisBusinesses pages to avoid huge logo */}
            <SidebarMenuComponent />
          </>
        )}
        <div className="app-content">
          <Routes>
            {/* <Route path="/" exact element={<Homepage />} /> */}
            <Route path="/" exact element={<YCLandingPage />} />
            <Route path="/blog" exact element={<Blog />} />
            <Route path="/blog/:id" exact element={<BlogDetail />} />
            <Route path="/testBelvoData" exact element={<BelvoTestData />} />
            <Route path="/signup" exact element={<Register />} />
            <Route path="/login" exact element={<Login />} />
            <Route
              path="/forgotPassword/:token"
              exact
              element={<ForgotPassword />}
            />
            <Route
              path="/forgotPasswordBusiness/:token"
              exact
              element={<ForgotPasswordBusiness />}
            />
            {/* <Route
              path="/widget/yoint/result/:userId"
              exact
              element={<YointResponse />}
            /> */}
            <Route path="/validateEmail" exact element={<EmailValidation />} />
            <Route
              path="/docs/terms&Conditions"
              exact
              element={<TermsAndConditions />}
            />
            <Route
              path="/docs/dataTreatment"
              exact
              element={<DataTreatment />}
            />
            <Route
              path="/docs/dataTreatmentAuthorization"
              exact
              element={<DataTreatmentAuhorization />}
            />
            <Route path="/docs/mandato" exact element={<Mandato />} />
            <Route
              path="/masterclass"
              exact
              element={<DownloadMasterClass />}
            />
            <Route
              path="/precreatedUserDownloadMantis"
              exact
              element={<PrecreatedUserDownloadMantis />}
            />
            {/* <Route
              path="/payment/approved"
              exact
              element={<ApprovedPayment />}
            /> */}

            <Route path="/aboutUs" exact element={<AboutUs />} />

            {props.authenticated && !props.isBusiness && (
              <>
                <Route
                  path="/dashboardMentor"
                  exact
                  element={<DashboardMentor />}
                />
                <Route
                  path="/dashboardMentor/user/:id"
                  exact
                  element={<DashboardMentorUser />}
                />
                <Route path="/backOffice" exact element={<BackofficeHome />} />
                <Route
                  path="/backoffice/recurringPayments"
                  exact
                  element={<MonthlyPayments />}
                />
                <Route
                  path="/backoffice/paymentLinks"
                  exact
                  element={<PaymentLinks />}
                />
                <Route
                  path="/backoffice/moneyOnMandates"
                  exact
                  element={<MoneyOnMandates />}
                />
                <Route
                  path="/backoffice/dashboard"
                  exact
                  element={<Dashboard />}
                />
                <Route
                  path="/backoffice/startcoConversations"
                  exact
                  element={<StartcoConversations />}
                />
                <Route path="/backoffice/billing" exact element={<Billing />} />
                <Route
                  path="/backoffice/investments"
                  exact
                  element={<Investments />}
                />
                <Route
                  path="/backoffice/investment/:id"
                  exact
                  element={<InvestmentDetail />}
                />
                <Route
                  path="/backoffice/recurringPayment/:id"
                  exact
                  element={<RecurringPaymentDetail />}
                />
                <Route path="/backoffice/tpaga" exact element={<Tpaga />} />
                <Route
                  path="/backoffice/planCalculator"
                  exact
                  element={<PlanCalculator />}
                />
                <Route
                  path="/backoffice/eficaciaDemo"
                  exact
                  element={<EficaciaDemo />}
                />
                <Route
                  path="/backoffice/whatsapp"
                  exact
                  element={<WhatsappNotifications />}
                />
                <Route
                  path="/backoffice/pushNotifications"
                  exact
                  element={<PushNotifications />}
                />
                <Route
                  path="/backoffice/mantisBusinesses"
                  exact
                  element={<MantisBusinesses />}
                />
                <Route
                  path="/backoffice/mantisBusinesses/:id"
                  exact
                  element={<MantisBusinessDetail />}
                />
                <Route
                  path="/backoffice/agentes"
                  exact
                  element={<Agentes />}
                />
                <Route
                  path="/backoffice/llm-models"
                  exact
                  element={<LLMModels />}
                />
                <Route
                  path="/backoffice/system-logs"
                  exact
                  element={<SystemLogs />}
                />
              </>
            )}
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default connect(select, mapDispatchToProps)(App);
